import * as v from "valibot";
import { rpcContract } from "../rpc";

export const updateEmailJobStatusRpcContract = rpcContract({
  name: "update-email-job-status",
  paramsSchema: v.object({
    jobId: v.string(),
    status: v.picklist(["completed", "failed", "cancelled"]),
    azureMessageId: v.nullish(v.string()),
    errorMessage: v.nullish(v.string()),
    retryable: v.optional(v.boolean()),
  }),
  resultSchema: v.object({ success: v.boolean() }),
});

export type UpdateEmailJobStatusParams = v.InferOutput<(typeof updateEmailJobStatusRpcContract)["paramsSchema"]>;
export type UpdateEmailJobStatusResult = v.InferOutput<(typeof updateEmailJobStatusRpcContract)["resultSchema"]>;
